import { createContext, useContext } from "react";

type SidePanelSlotContextValue = {
  slot: HTMLElement | null;
};

export const SidePanelSlotContext = createContext<SidePanelSlotContextValue>({
  slot: null,
});

export const useSidePanelSlot = (): SidePanelSlotContextValue =>
  useContext(SidePanelSlotContext);
